import { Component, Input, OnInit } from '@angular/core';
import { Device } from "../../../../model/device";

@Component({
  selector: 'app-device-technical-details',
  templateUrl: './device-technical-details.component.html',
  styleUrls: ['./device-technical-details.component.scss']
})
export class DeviceTechnicalDetailsComponent implements OnInit {

  @Input()
  device: Device;

  jsonData: object;
  loadingTechnicalDetails: boolean;

  constructor() { }

  ngOnInit(): void {
    this.loadingTechnicalDetails = true;
    if(this.device.technicalDetails && this.device.technicalDetails !== 'null') {
      this.jsonData = JSON.parse(this.device.technicalDetails);
    }
    this.loadingTechnicalDetails = false;
  }

}
